import React, { useState } from 'react';
import '../CSS/App.css';
import { NavScroll } from './NavBar';
import SocialLinks from "./SocialLinks";
import faqData from '../data/faq.json';

export default function Faq() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (key) => {
    setOpenItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Filter FAQ items
  const filteredFAQ = faqData.map(category => {
    // If a category is selected and it doesn't match, return null
    if (selectedCategory !== 'All' && category.category !== selectedCategory) {
      return null;
    }

    // Filter questions inside the category based on search query
    const filteredItems = category.items.filter(item => {
      if (!searchQuery) return true;
      return (
        item.q.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.a.toLowerCase().includes(searchQuery.toLowerCase())
      );
    });

    if (filteredItems.length === 0) return null;

    return {
      ...category,
      items: filteredItems
    };
  }).filter(Boolean); // Filter out null categories

  return (
    <div className='background-component'>
      <NavScroll />

      <div className="faq-container">
        <h1 className="faq-title">Frequently Asked Questions</h1>

        {/* Search Bar */}
        <div className="faq-search-wrapper">
          <input
            type="text"
            placeholder="Search questions, categories, or keywords..."
            className="faq-search-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Category Selectors */}
        <div className="faq-categories">
          <button
            className={`faq-cat-btn ${selectedCategory === 'All' ? 'active' : ''}`}
            onClick={() => setSelectedCategory('All')}
          >
            All Topics
          </button>
          {faqData.map(cat => (
            <button
              key={cat.category}
              className={`faq-cat-btn ${selectedCategory === cat.category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat.category)}
            >
              {cat.category}
            </button>
          ))}
        </div>

        {/* FAQ Scrollable Content */}
        <div className="faq-content-scrollable">
          {filteredFAQ.length === 0 ? (
            <div className="faq-no-results">
              No questions found matching your search. Try different keywords!
            </div>
          ) : (
            filteredFAQ.map(cat => (
              <div key={cat.category} className="faq-category-block">
                <h2 className="faq-category-title">
                  {cat.category}
                </h2>
                <div className="faq-items-list">
                  {cat.items.map((item, idx) => {
                    const itemKey = `${cat.category}-${idx}`;
                    const isOpen = !!openItems[itemKey];
                    return (
                      <div
                        key={itemKey}
                        className={`faq-item-card ${isOpen ? 'open' : ''}`}
                      >
                        <div
                          className="faq-item-question"
                          onClick={() => toggleItem(itemKey)}
                        >
                          <h3>{item.q}</h3>
                          <span className={`faq-chevron-icon ${isOpen ? 'rotate' : ''}`}>▼</span>
                        </div>
                        <div className={`faq-item-answer ${isOpen ? 'expanded' : ''}`}>
                          <p>{item.a}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <SocialLinks />
    </div>
  );
}
